import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SocketService } from './core/services/socket.service';
import { TokenService } from './core/services/token.service';
import { NotificationService } from './core/services/notification.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'safe-ignite';
  deferredPrompt: any;
  checked: boolean = false;
  constructor(
    private socket: SocketService,
    private token: TokenService,
    private translate: TranslateService,
    private notificationService: NotificationService
  ) {
    this.translate.setDefaultLang('en');
    const savedLang = localStorage.getItem('lang') || 'en';

  this.translate.use(savedLang);
  }

  ngOnInit() {
      window.addEventListener(
    'beforeinstallprompt',
    (e: any) => {

      e.preventDefault();

      this.deferredPrompt = e;
    }
  );

  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.register('/firebase-messaging-sw.js')
      .then(() => {})
      .catch(err => {});
  }

  // ✅ Initialize Firebase notifications
  this.notificationService.requestPermission();
  this.notificationService.listen();

  if (this.token.isLoggedIn()) {
    this.socket.connect();
  }
}
async installPWA() {

  if (!this.deferredPrompt) return;

  this.deferredPrompt.prompt();

  await this.deferredPrompt.userChoice;

  this.deferredPrompt = null;
}

}

